import { useCallback } from 'react';
import { useTranslator } from '@picsart/rc/services/localization';

import { useAppStore } from '@/store';
import { ToastType } from '@/store/toast/types';

/**
 * `Lightbox`'s `onPlaybackError`: the error toast its callers show when audio
 * fails to play. Lives with the callers so the lightbox itself stays
 * props-only.
 */
const useLightboxPlaybackError = () => {
  const translate = useTranslator();
  const showToast = useAppStore((state) => state.showToast);

  return useCallback(() => {
    showToast(
      translate('Playback unavailable. Please try again.'),
      ToastType.Error
    );
  }, [showToast, translate]);
};

export default useLightboxPlaybackError;
